import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../Services/shared.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { VlHttpService, VlDataService, APIConfigMapping, HTTPAPIConfig, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';
import { WORKFLOW_EVENT_TYPES } from '../../../../constants/proj.cnst';
// import { Stage } from 'ngx-mobile-app';
import { Subject } from 'rxjs';


@Component({
  selector: 'lib-workflow',
  templateUrl: './workflow.component.html',
  styleUrl: './workflow.component.scss'
})

export class WorkflowComponent implements OnInit,OnDestroy{


  @Input() newWorkFlowAdded:boolean =false;
  @Input() queryParams:any ={};

  eventTypes = WORKFLOW_EVENT_TYPES
    // Reference to the paginator
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild("addWorkFlowPopUp") workFlowtemplate!: TemplateRef<any>;


    @Input() entity:any;
    // All workflows
    @Input() workflowEntityList: any[] = [];
    filteredWorkflows: any[] = [];
    isEntityNameUnique:boolean = false;
     destroy$:Subject<void> = new Subject<void>();
     popupEntity!: { entityId: string | null; entityName: string | null; };
    
    // Filtered and paginated workflows
    displayedWorkflows: any[] = [];
    
    stageWorkFlowList: any[] = [];
    stageSpinner: boolean = false;
    selectedStageId: string = '';

    editWorkFlowId:any;
    isEdit: boolean = false;

    selectedWorkflowIndex:any;
    // entity: any; // Your entity object
    
    // Pagination
    pageSize: number = 5;
    pageSizeOptions: number[] = [5,10, 20, 50, 100];
    totalItems: number = 0;
    startIndex:number = 0;
    
    // Search
    searchControl = new FormControl('');

      workFlowForm: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        stages: new FormArray([])
      });
      workflowSpinner:boolean = false;

    workFlowDeleteEntity!: { deleteId: string; deleteName: string; entityId: string; };

    appPermissions = APP_BUILDER_PERMISSIONS;
    permissionsActions = PERMISSIONS_ACTIONS;
    
    constructor (private toastrService: ToastrService,
        private sharedService:SharedService,
        private httpService: VlHttpService,
        private dataService: VlDataService,
        private route: ActivatedRoute,
        public dialog: MatDialog) { }
    
    ngOnInit() {
      this.displayedWorkflows = [];
      this.fetchWorkFlows(this.entity.entity_id,'first')
      // this.totalItems = this.workflowEntityList.length;
      // this.filteredWorkflows = this.workflowEntityList;
     

      this.subscribeWorkFlowEvents();
    }

    subscribeWorkFlowEvents() {
      this.sharedService.workflowSubject$.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
        if(response.status) {
          this.fetchWorkFlows(response.entity,'update');
        }
      })

       // Setup search with debounce
       this.searchControl.valueChanges
       .pipe(
         debounceTime(300),
         distinctUntilChanged()
       )
       .subscribe(searchTerm => {
         if (this.paginator) {
           this.paginator.firstPage();
         }
         this.filterWorkflows();
       });
    }

    
    
    filterWorkflows() {
      const searchTerm = this.searchControl.value?.toLowerCase() || '';
      
      // Filter workflows based on search term
      this.filteredWorkflows = this.workflowEntityList.filter(workflow => 
        workflow.workflow_name.toLowerCase().includes(searchTerm)
      );
      
      this.totalItems = this.filteredWorkflows.length;
      this.updateDisplayedWorkflows();
    }
    
    updateDisplayedWorkflows() {
      this.startIndex = this.paginator ? this.paginator.pageIndex * this.paginator.pageSize : 0;
      this.pageSize = this.paginator ? this.paginator.pageSize : this.pageSize;
      
      this.displayedWorkflows = this.filteredWorkflows.slice(this.startIndex, this.startIndex + this.pageSize);
      this.displayedWorkflows.forEach((workflow:any) => {
        workflow.open = false;
      })
    }
    
    onPageChange(event: PageEvent) {
      this.displayedWorkflows.forEach((workflow:any) => {
        workflow.open = false;
      })
      this.updateDisplayedWorkflows();
    }
    
   async toggleWorkFlow(status: boolean, workFlow: any, index: number,eventType:string) {
    // if([this.eventTypes.closed,this.eventTypes.]){
      this.displayedWorkflows[index].open = status;
    // }
     this.selectedStageId = '';
     if(eventType !== this.eventTypes.closed){
       this.selectedWorkflowIndex = index;
     }
     if(eventType !== this.eventTypes.update){
       this.sharedService.setSidenavContentlistOption('',false);
     }
     this.stageArray.clear();
     if(status) {
       this.stageSpinner = true;
       const workFlowDetails = await this.fetchWorkFlowDetails(workFlow?.worflow_id);
       this.getStageList(workFlowDetails.stages, workFlow?.worflow_id,eventType);
       this.stageSpinner = false;
     }
   }

   getStageList(stageList: any, worflowId: string,eventType:string) {
    this.stageWorkFlowList = [];
    for(const stage of stageList) {
      this.stageWorkFlowList.push({
        stage_id: stage['stage_id'],
        stage_name: stage['stage_name'],
        workflow_id: worflowId
      })
    }
  }

   fetchWorkFlowDetails(workFlowId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_FETCH']);
    apiConfig.postData = {
      fetch_type: 'workflow',
      fetch_id: workFlowId
    }
    return new Promise<any>((resolve, reject) => {
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
        next: (response: any) => {
          if(response.result) {
            resolve(response.response)
          }
        },
        complete: () => {
        },
        error: (error: Error) => {
          this.stageSpinner = false
          this.toastrService.error('Error in Fetching Details');
          reject(error);
        }
      })
    }) 
  }

  openModal(template:TemplateRef<any>, isEdit: boolean, entityId: string | null = null, entityName: string | null = null): void {
    this.isEntityNameUnique = true;
    // this.entityForm.reset();
    this.dialog.open(template, {
      disableClose: true,
      restoreFocus:false
    });
    this.isEdit = isEdit;
    this.popupEntity = {
      entityId,
      entityName
    }
  }
    


  setStageDetailsForWorkFlow(stageList: any[]) {
    const returnData = [];
    for(const stage of stageList) {
      this.addStage(stage['stage_name']);
      const stageData = {
        name: stage['stage_name']
      }
      returnData.push(stageData);
    }
    return returnData; 
  }

  get stageArray(): FormArray {
    return this.workFlowForm.get("stages") as FormArray;
  }

  addStageGroup(stageName: string = '') {
    return new FormGroup({
      name: new FormControl(stageName, [Validators.required])
    });
  }

  addStage(stageName: string = '') {
    this.stageArray.push(this.addStageGroup(stageName));
  }

  deleteStage(index: number) {
    this.stageArray.removeAt(index)
  }


    
    // openWorkFlowDeleteModal(modal: any, id: string, name: string, entityId: string) {
    //   // Implement your delete modal logic
    // }
    
    setStageConfiguration(stageId: string, workflowId: string, entityId: string, isEdit: boolean,stage:any) {
      this.selectedStageId = stageId;
      this.sharedService.onMobileScreenDropUpdateData({stage: stageId, isEdit: isEdit, workflow: workflowId, entity: entityId,stageName:stage.stage_name})
      this.sharedService.setSidenavContentlistOption('stage',true);
    }

     openWorkFlowDeleteModal(template:TemplateRef<any>, deleteId: string, deleteName: string, entityId: string): void {
        this.dialog.open(template, {
          disableClose: true,
          restoreFocus:false
        });
        this.workFlowDeleteEntity = { deleteId, deleteName, entityId };
      }



      deleteWorkFlow(workFlowId: string, entityId: string) {
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_DELETE']);
    
        apiConfig.postData = {
          workflow_id: workFlowId
        }
    
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
          next: (response: any) => {
            this.toastrService.success(response.message);
          },
          complete: () => {
            this.closeTemplate();
            this.fetchWorkFlows(entityId,'delete');
          },
          error: (error: any) => {
            this.toastrService.error('Error in Deletion of Entity');
          }
        })
      }
    
      deleteStageFromWorkFlow(stageId: string) {
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['STAGE_DELETE']);
    
        apiConfig.postData = {
          stage_id: stageId
        }
    
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
          next: (response: any) => {
            this.toastrService.success(response.message);
          },
          complete: () => {
            this.closeTemplate();
            const index = this.stageWorkFlowList.findIndex((stage: any) => stage.stage_id === stageId);
            this.stageWorkFlowList.splice(index, 1);
          },
          error: (error: any) => {
            console.log(error, 'Error in Deletion of Entity');
            this.toastrService.error('Error in Deletion of Entity');
          }
        })
      }

      closeTemplate(): void {
        this.dialog.closeAll();
      }

      fetchWorkFlows(entityId: string,action:string) {
        if(action != 'update'){
          this.workflowSpinner = true;
        }
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_FETCH']);
        apiConfig.postData = {
          fetch_type: 'entity',
          fetch_id: entityId
        }
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
          next: (response: any) => {
            if(response.result) {
              this.setWorkFlowList(response.response, entityId);
              this.totalItems = this.workflowEntityList.length;

            }
          },
          complete: () => {
            if(action === "first"){
              this.filteredWorkflows = this.workflowEntityList;
              this.startIndex = 0;
              this.displayedWorkflows = this.workflowEntityList.slice(this.startIndex,this.startIndex + this.pageSize);
            }
            if(action === "new"){
              this.searchControl.patchValue('',{emitEvent:false,onlySelf:true});
              this.filteredWorkflows = this.workflowEntityList;
              this.startIndex = 0;
              
              this.displayedWorkflows = this.workflowEntityList.slice(this.startIndex,this.startIndex + this.pageSize);

              if(this.paginator){
                this.paginator.firstPage();
              }
              setTimeout(() => {
                this.toggleWorkFlow(true,this.displayedWorkflows[0],0,this.eventTypes.click)
              },30)
              // if(this.displayedWorkflows[0]){
              //   this.displayedWorkflows[0].open = true;
              // }
              
            }else if(action === 'update'){
              
              this.displayedWorkflows[this.selectedWorkflowIndex]['open'] = true;
              if(this.displayedWorkflows[this.selectedWorkflowIndex]){
                if(this.isEdit){
                  let workflowId = this.displayedWorkflows[this.selectedWorkflowIndex].workflow_id;
                  let workflow = this.workflowEntityList.find((workflow:any) => workflow.workflow_id === workflowId);

                  this.displayedWorkflows[this.selectedWorkflowIndex] = workflow;

                }
                this.toggleWorkFlow(true,this.displayedWorkflows[this.selectedWorkflowIndex],this.selectedWorkflowIndex,this.eventTypes.update)
              }
            }else if(action === 'delete'){
              this.filteredWorkflows = this.workflowEntityList;
              this.displayedWorkflows = this.workflowEntityList.slice(this.startIndex,this.startIndex + this.pageSize);
            }
            this.workflowSpinner = false;
          },
          error: (error: Error) => {
            this.workflowSpinner = false
            console.log(error, 'Error in Fetching WorkFlows');
            this.toastrService.error('Error in Fetching WorkFlows');
          }
        })
      }

       setWorkFlowList(workFlowList: any[], entityId: string) {
          let count = 0;
          this.workflowEntityList = [];
          this.newWorkFlowAdded = false;
          let openedWorkflow;
          for(let workflow of workFlowList) {
            count++;
            const workFlowEntity: any = {
              worflow_id: workflow.workflow_id,
              workflow_name: workflow.workflow_name,
              entity_id: entityId,
              open: false
            }
            this.workflowEntityList.push(workFlowEntity);
            if(workFlowEntity.open){
              openedWorkflow = workFlowEntity;
            }
          }
        }

      


      openWorkFlowModal(template:TemplateRef<any>, isEdit: boolean, entityId: string | null = null, entityName: string | null = null): void {
        this.workFlowForm.reset();
        this.stageArray.clear();
        this.stageArray.push(this.addStageGroup());
        this.stageArray.push(this.addStageGroup());
        this.openModal(template, isEdit, entityId, entityName)
      }


      saveWorkFlow(entityId: string | null, isEdit: boolean) {    
         if(entityId) {
           const workflow: any = {
             entity_id: entityId,
             worflow_id: isEdit ? this.editWorkFlowId: '',
             workflow_name: this.workFlowForm.get('name')?.value,
             open: true
           };
           this.createWorkFlow(workflow, isEdit);
         }    
         this.closeTemplate();
       }
     
     createWorkflowPayload(workFlow: any, isEdit: boolean) {
        if(isEdit) {
          return {
            workflow_id: workFlow.worflow_id,
            workflow_name: workFlow.workflow_name,
            workflow_description: '',
            workflow_config: null,
            stage_config: null
          }
        }else {
          return {
            application_id: this.queryParams['id'],
            workflow_name: workFlow.workflow_name,
            entity_id: workFlow.entity_id,
            workflow_description: '',
            workflow_config: null,
            stage_config: null,
            userId: JSON.parse(localStorage.getItem('userInfo') ?? 'null').userId
          }
        }
      }
    
      createWorkFlow(workFlow: any, isEdit: boolean) {
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_CREATE_UPDATE']);
        apiConfig.postData = this.createWorkflowPayload(workFlow, isEdit);
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
          next: (response: any) => {
            if(!isEdit) {
              (async () => {
                this.newWorkFlowAdded = false;
                await this.setStageList(response.response);
                workFlow.worflow_id = response.response.workflow_id
                this.workflowEntityList.push(workFlow);
                this.newWorkFlowAdded = true;
                // this.toggleWorkFlow(true,workFlow,this.selectedWorkflowIndex,this.eventTypes.click);
    
              })();
            }
          },
          complete: () => {
              this.closeTemplate();
              this.fetchWorkFlows(workFlow.entity_id,isEdit ? 'update':'new');
          },
          error: (error: any) => {
            console.log(error, 'Error in Creating WorkFlow');
            if(error?.status == 403) {
              this.toastrService.error('You do not have permission to access this resource.');
            }else{
              this.toastrService.error(error?.error?.message ?? 'Error in Creating WorkFlow');
            }
          }
        })
      }
    
      async setStageList(workFlow: any) {
        const stagePromises = this.stageArray.controls.map(stageControl => {
          const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['STAGE_CREATE_UPDATE']);
          apiConfig.postData = {
            workflow_id: workFlow.workflow_id,
            stage_name: stageControl.get('name')?.value,
            stage_description: '',
            stage_type: 'mandatory',
            stage_config: null,
            userId: JSON.parse(localStorage.getItem('userInfo') ?? 'null').userId
          };
      
          return new Promise((resolve, reject) => {
            this.httpService.placeAPICall(apiConfig).pipe(take(1)).subscribe({
              next: (response: any) => {
                resolve(response.response);
              },
              error: (error: Error) => {
                console.log(error, 'Error in Creating Stage');
                this.toastrService.error('Error in Creating Stage:', stageControl.get('name')?.value);
                reject(error);
              }
            });
          });
        });
      
        await Promise.all(stagePromises); // Run all API calls in parallel
      }
    

      async editWorkFlow(workFlowId: string,index:number) {
        this.selectedWorkflowIndex = index
        this.editWorkFlowId = workFlowId;
        this.workFlowForm.reset();
        this.stageArray.clear();
        const workFlowDetails = await this.fetchWorkFlowDetails(workFlowId);
        const workFlowName = workFlowDetails.workflow_name;
        this.workFlowForm.get('name')?.setValue(workFlowName);
        const stageDetails = this.setStageDetailsForWorkFlow(workFlowDetails.stages);
        this.openModal(this.workFlowtemplate, true, workFlowDetails.entity_id);
        this.workFlowForm.patchValue({
          name:workFlowName,
          stages: stageDetails
        })
      }







    ngOnDestroy(): void {
      this.workflowEntityList = [];
      this.filteredWorkflows = [];
      this.displayedWorkflows = [];
      this.entity = null;
      this.destroy$.next();
      this.destroy$.complete();
    }

 

}
